import {  ArrayObservable  } from './ArrayObservable';

export const of = ArrayObservable.of;


// WEBPACK FOOTER //
// ../../../../node_modules/src/observable/of.ts